const icon = function (event) {

    let testo = document.getElementById("selezionato")
    let bologna = document.getElementById("bolognaicon")
    let piantata = document.getElementById("piantataicon")
    let ferrara = document.getElementById("ferraraicon")
    let parma = document.getElementById("parmaicon")
    let modena = document.getElementById("modenaicon")

    if(testo != null)
    {
        bologna.onmouseover=function()
        {
            testo.innerHTML="Bologna"
        }
    
        bologna.onmouseout=function()
        {
            testo.innerHTML=""
        }

        // la piantata
        piantata.onmouseover=function()
        {
            testo.innerHTML="La Piantata"
        }
    
        piantata.onmouseout=function()
        {
            testo.innerHTML=""
        }

        ferrara.onmouseover=function()
        {
            testo.innerHTML="Ferrara"
        }
    
        ferrara.onmouseout=function()
        {
            testo.innerHTML=""
        }

        parma.onmouseover=function()
        {
            testo.innerHTML="Parma"
        }
    
        parma.onmouseout=function()
        {
            testo.innerHTML=""
        }

        modena.onmouseover=function()
        {
            testo.innerHTML="Modena"
        }
    
        modena.onmouseout=function()
        {
            testo.innerHTML=""
        }
    }
}

module.exports = icon;
